import React from 'react'
import { Photo } from '@app-types/entity_types'
import FormattedTime from '@components/FormattedTime'
import { sanitize } from '@utils/sanitize'
import { DerivedMarker } from '../../types/derived_items'

interface DefaultMarkerContentProps {
  marker: DerivedMarker
  photoData: Photo | null
  imageComponent: React.ReactNode
}

const DefaultMarkerContent = ({ imageComponent, marker }: DefaultMarkerContentProps) => {
  return (
    <div className="content-holder">
      <div className="content-body">
        {imageComponent}
        <div className="marker-text-content">
          <div className="tooltip-title">
            <FormattedTime dateTime={marker.date} />,{' '}
            <span dangerouslySetInnerHTML={{ __html: sanitize(marker.title) }}></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DefaultMarkerContent
